import { useQuery } from '@tanstack/react-query';

import { fetchClient } from '@/lib/openapi-fetch/fetchClient';
import { mapPublicCandidateJob } from '@/modules/public-shortlist/mapPublicCandidate';
import { shortlistQueryKeys } from '@/modules/public-shortlist/queries/queryKeys';

export const usePublicJobCandidatesQuery = (code: string) => {
  return useQuery({
    queryKey: shortlistQueryKeys.publicJobCandidates(code),
    queryFn: async () => {
      const { data } = await fetchClient.GET('/public/jobs/{code}/candidates', {
        params: { path: { code } },
      });

      return (data ?? []).map((candidate) => mapPublicCandidateJob(candidate));
    },
    enabled: Boolean(code),
  });
};
